import { render } from "./Form.vue?vue&type=template&id=b8ed3f06&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=b8ed3f06&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b8ed3f06"

export default script